import { calculateDefaultAnnualEarnings } from '../utils/earningsFormulas';

export const useOnboardingEarningsInputs = ({
    monthlyIncome,
    monthlyBills,
}: {
    monthlyIncome: number;
    monthlyBills: number;
}) => {
    const monthlySpendingDefault = Math.max(monthlyBills, 0);
    const monthlySavingsDefault = Math.max(
        monthlyIncome - monthlySpendingDefault,
        0,
    );
    const startingCashDefault = 5000;
    const totalCash = 200000; // max slider amount
    const annualEarningsDefault = calculateDefaultAnnualEarnings(
        monthlySpendingDefault,
        monthlySavingsDefault,
        startingCashDefault,
    );

    return {
        monthlyIncome,
        monthlySpendingDefault,
        monthlySavingsDefault,
        startingCashDefault,
        totalCash,
        annualEarningsDefault,
    };
};
